import { useEffect, useState } from "react";
import { api } from "../../lib/api";

const money = (n) => `${Number(n || 0).toFixed(2).replace(".", ",")} $`;

// Accueil (matin) : paiements Stripe reçus la veille — membre, motif, montant, carte, lien Stripe.
export function DailyCashflowCard() {
  const [d, setD] = useState(null);
  const [date, setDate] = useState("");
  useEffect(() => { api.get(`/billing/daily-cashflow${date ? `?date=${date}` : ""}`).then((r) => setD(r.data)).catch(() => setD({ rows: [], error: true })); }, [date]);
  if (!d) return null;
  return (
    <div className="mx-6 md:mx-8 lg:mx-10 mt-6 rounded-xl border border-emerald-600/40 bg-emerald-500/[0.05] p-4" data-testid="daily-cashflow-card">
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="text-[10px] uppercase tracking-[0.2em] text-emerald-300 font-semibold">Encaissements · {d.label === "hier" ? "hier" : d.date}</p>
          <h3 className="text-zinc-100 font-bold mt-0.5" data-testid="daily-cashflow-title">{money(d.total)} reçus · {d.count} paiement{d.count > 1 ? "s" : ""}</h3>
          {d.by_motif && Object.keys(d.by_motif).length > 0 && <p className="text-xs text-zinc-400 mt-0.5">{Object.entries(d.by_motif).map(([m, v]) => `${m} ${money(v)}`).join(" · ")}</p>}
          {d.stripe_error && <p className="text-xs text-rose-300 mt-0.5">Stripe indisponible : {d.stripe_error}</p>}
        </div>
        <input type="date" value={date || d.date} onChange={(e) => setDate(e.target.value)} className="bg-zinc-900 border border-zinc-700 rounded px-2 py-1 text-xs text-zinc-200" data-testid="daily-cashflow-date" />
      </div>
      {d.rows.length === 0 ? <p className="text-xs text-zinc-500 mt-2" data-testid="daily-cashflow-empty">Aucun paiement reçu ce jour-là.</p> : (
        <table className="w-full text-xs mt-3" data-testid="daily-cashflow-table">
          <thead className="text-zinc-500 text-left"><tr><th className="py-1">Heure</th><th>Membre</th><th>Motif</th><th>Moyen</th><th className="text-right">Montant</th><th></th></tr></thead>
          <tbody>
            {d.rows.map((r, i) => (
              <tr key={i} className={`border-t border-zinc-800/60 ${r.refunded ? "opacity-50 line-through" : ""}`} data-testid={`daily-cashflow-row-${i}`}>
                <td className="py-1 text-zinc-400">{r.time}</td>
                <td className="text-zinc-100 font-medium">{r.member}<div className="text-zinc-500 font-normal">{r.email}</div></td>
                <td className="text-zinc-300">{r.motif}</td>
                <td className="text-zinc-400">{r.card || "—"}</td>
                <td className="text-right text-emerald-300 font-semibold">{money(r.amount)}</td>
                <td className="text-right">{r.dashboard_url && <a href={r.dashboard_url} target="_blank" rel="noreferrer" className="text-[#C9A961] underline">Stripe</a>}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
